import { z } from 'zod';
import { BannedTailNumberFormType } from '@/api/apis/resources';
import { MAX_LENGTH_2000 } from '@/constants/form.constants';

export const BANNED_TAIL_NUMBERS_DEFAULT_VALUES: BannedTailNumberFormType = {
  tailNumber: '',
  logisticProviderId: '',
  comment: '',
};

export const bannedTailNumbersFormSchema = z.object({
  tailNumber: z
    .string()
    .min(1, 'Provide banned tail number name')
    .max(10, 'Tail number is too long (maximum 10 characters)'),
  logisticProviderId: z.string().nullable(),
  comment: z.string().max(MAX_LENGTH_2000, `Maximum length: up to ${MAX_LENGTH_2000} symbols`).optional(),
});
